/**
 * While the wrapped async function is running, make it so closing the browser tab will give a
 * warning message from the browser.
 */
export default async function withWarnOnClose<T>(f: () => Promise<T>): Promise<T> {
  // Create a new handler function each time to avoid reentrancy issues.
  function handleBeforeUnload(e: BeforeUnloadEvent): void {
    e.preventDefault();
    e.returnValue = '';
  }
  window.addEventListener('beforeunload', handleBeforeUnload);
  try {
    return await f();
  } finally {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  }
}
